const jsSHA = require("jssha");

function resetForm(formElement) {
  hideError();
  formElement.trigger("reset");
  //$(".w-form-done").html("<div></div>");
  $(".w-form-done").hide();
  formElement.show();
}

function getProduct(url) {
  if (url.indexOf("anglais") !== -1) {
    return "Formation d'anglais";
  }
  if (url.indexOf("allemand") !== -1) {
    return "Formation d'allemand";
  }
  if (url.indexOf("espagnol") !== -1) {
    return "Formation d'espagnol";
  }
  if (url.indexOf("italien") !== -1) {
    return "Formation d'italien";
  }
  if (url.indexOf("francais") !== -1) {
    return "Formation de francais";
  }

  return "-";
}

function submitForm(formElement) {
  var url = "https://api.educastream.com/save_form_register";
  //var url = "https://run.mocky.io/v3/f0c86150-e409-4c79-9aac-7d7ec948280e";
  //var url = "https://run.mocky.io/v3/d1d9ca68-1c3e-4fef-8a78-87e37307f8eb";

  $.ajax({
    type: "POST",
    url: url,
    dataType: "json",
    contentType: "application/x-www-form-urlencoded",
    beforeSend: function (xhr) {
      xhr.setRequestHeader(
        "Authorization",
        "Bearer AMrpZVZFe4JE_ZwwKvVn6HZ3!Xvy4LCP8aCuv6uTM"
      );
    },
    data: formElement.serialize(), // serializes the form's elements.
    success: function (response) {
      //console.log(response);

      if (response.return_code != 0) {
        enableForm(formElement);
        showError(response.description);
      } else {
        //data layer
        if (typeof dataLayer !== "undefined" && dataLayer.length > 0) {
          var cleanPhone = $("#phone").val().replace("+", "");

          var shaObjEmail = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
          shaObjEmail.update($("#email").val());

          var shaObjName = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
          shaObjName.update(
            $("#first_name").val() + " " + $("#last_name").val()
          );

          var shaObjPhone = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
          shaObjPhone.update(cleanPhone);

          dataLayer.push({
            event: "lead",
            crm_pipe: "close",
            funnel_name: "inscription_form",
            lead_rdv: "lead avec rendez-vous",
            lead_id: parseInt(response.order_id),
            lead_prospect: $("#profil").val(),
            lead_selection_produit: getProduct($("#page").val()),
            hash_ue: $("#email").val(),
            hash_ufn: $("#first_name").val() + " " + $("#last_name").val(),
            hash_uph: cleanPhone,
            source: $("#utm_source").val(),
            medium: $("#utm_medium").val(),
            campaign: $("#utm_campaign").val(),
            clic_id: $("#gclid").val(),
          });

          /*console.log({
            event: "lead",
            crm_pipe: "close",
            funnel_name: "inscription_form",
            lead_rdv: "lead avec rendez-vous",
            lead_id: parseInt(response.order_id),
            lead_prospect: $("#profil").val(),
            lead_selection_produit: getProduct($("#page").val()),
            hash_ue: $("#email").val(),
            hash_ufn: $("#first_name").val() + " " + $("#last_name").val(),
            hash_uph: cleanPhone,
            source: $("#utm_source").val(),
            medium: $("#utm_medium").val(),
            campaign: $("#utm_campaign").val(),
            clic_id: $("#gclid").val(),
          });*/
        }

        //reset
        $(".w-form-done").show();
        formElement.hide();
        enableForm(formElement);
      }
    },
  });
}

function disableForm(formElement) {
  var toKeep = formElement.find("input[type=submit]").val();

  formElement.find("input[type=submit]").attr("disabled", true);
  formElement
    .find("input[type=submit]")
    .val(formElement.find("input[type=submit]").attr("data-wait"));
  formElement.find("input[type=submit]").attr("data-wait", toKeep);
  formElement.css("opacity", 0.5);
}

function enableForm(formElement) {
  var toKeep = formElement.find("input[type=submit]").val();

  formElement.find("input[type=submit]").attr("disabled", false);
  formElement
    .find("input[type=submit]")
    .val(formElement.find("input[type=submit]").attr("data-wait"));
  formElement.find("input[type=submit]").attr("data-wait", toKeep);
  formElement.css("opacity", 1);
}

function showError(text) {
  $(".w-form-fail").html("<div>" + text + "</div>");
  $(".w-form-fail").show();
}

function hideError() {
  $(".w-form-fail").html("<div></div>");
  $(".w-form-fail").hide();
}

export { submitForm, resetForm, disableForm, enableForm, showError, hideError };
